export default __webpack_public_path__ + "static/media/group-lframe-card.21087a6b.png";